function loadScript() {
  // <!-- Nextop LiveChat {literal} -->
  (function(d,w,c){w.NextopLiveChatID='LIVECHAT:1758792152404:752942340636196864';w[c]=w[c]||function(){(w[c].q=w[c].q||[]).push(arguments)};var s=d.createElement('script');s.async=true;s.src='https://livechat.nextop.com/nextop-im-sdk.min.js';if(d.head)d.head.appendChild(s)})(document,window,'NextopLiveChat');
  // <!-- / Nextop LiveChat {/literal} -->

  window.removeEventListener('scroll', loadScript);
}
window.addEventListener('scroll', loadScript);


// GTM
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-8TTQ3K6J4G');